import { Badge } from "@/components/ui/badge";
import type { Role } from "@/api/permissions";

const ROLE_STYLES: Record<Role, string> = {
  superadmin: "bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-300",
  support: "bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-300",
  readonly: "bg-muted text-muted-foreground",
  marketing:
    "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300",
};

export function RoleBadge({ role }: { role: Role }) {
  return (
    <Badge variant="secondary" className={ROLE_STYLES[role]}>
      {role}
    </Badge>
  );
}
